import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useStore } from "@dp/state";
import { Box, Button, HStack, Pressable } from "native-base";
import { observer } from "mobx-react-lite";
import Trackable from "../Trackable";
import BrandIcon from "../BrandIcon";
import { isTrue } from "@dp/common";
import ShareButton from "../../ReservationConfirmation/components/ShareButton";
import { BrandHeaderLogo } from "../BrandHeaderLogo";

var ReservationConfirmationHeader = function ReservationConfirmationHeader() {
  var _store$common;

  var store = useStore();
  var globalBannerMessage = store === null || store === void 0 ? void 0 : (_store$common = store.common) === null || _store$common === void 0 ? void 0 : _store$common.shouldShowGlobalBanner;
  var isMobile = store === null || store === void 0 ? void 0 : store.isMobile;
  var platformUtil = store.platformUtil;
  return /*#__PURE__*/_jsxs(HStack, {
    width: "100%",
    bg: isTrue(isMobile, "headerBackgroundTop", "headerBackground"),
    top: globalBannerMessage ? isTrue(isMobile, "38px", "40px") : 0,
    left: 0,
    right: 0,
    alignItems: "center",
    justifyContent: "space-between",
    py: isTrue(isMobile, 3, 4),
    px: isTrue(isMobile, 3, 6),
    _ios: {
      height: isTrue(isMobile, 20, 24)
    },
    _android: {
      height: isTrue(isMobile, 20, 24)
    },
    _web: {
      position: "fixed",
      height: isTrue(isMobile, "77px", "91px")
    },
    borderBottomWidth: isTrue(isMobile, 0, 1),
    borderBottomColor: "themeSectionSeparator",
    children: [/*#__PURE__*/_jsx(Pressable, {
      onPress: function onPress() {
        var _store$platformUtil, _store$platformUtil$n;

        store === null || store === void 0 ? void 0 : (_store$platformUtil = store.platformUtil) === null || _store$platformUtil === void 0 ? void 0 : (_store$platformUtil$n = _store$platformUtil.navHistory()) === null || _store$platformUtil$n === void 0 ? void 0 : _store$platformUtil$n.back();
      },
      children: /*#__PURE__*/_jsx(BrandIcon, {
        alt: "back arrow",
        iconName: "jw-header-arrow",
        h: "16px",
        w: "20px"
      })
    }), /*#__PURE__*/_jsx(Trackable, {
      className: "trackContent",
      dataLinkInfo: "mobile header | logo link",
      children: /*#__PURE__*/_jsx(Button, {
        variant: "ghost",
        p: 0,
        onPress: function onPress() {
          //NOOP
          platformUtil === null || platformUtil === void 0 ? void 0 : platformUtil.navigateToRoute("/home");
        },
        children: /*#__PURE__*/_jsx(Box, {
          _ios: {
            height: isTrue(isMobile, 12, 16),
            width: isTrue(isMobile, 40, 48)
          },
          _android: {
            height: isTrue(isMobile, 12, 16),
            width: isTrue(isMobile, 40, 48)
          },
          _web: {
            height: isTrue(isMobile, "50px", "57px"),
            width: isTrue(isMobile, "166px", "190px")
          },
          children: /*#__PURE__*/_jsx(BrandHeaderLogo, {
            alt: "brand-logo",
            iconName: "brand-logo",
            h: "100%",
            w: "100%"
          })
        })
      })
    }), /*#__PURE__*/_jsx(ShareButton, {})]
  });
};

export default observer(ReservationConfirmationHeader);